import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../Component/Component.css/Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  const handleLinkClick = () => {
    setOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="logo">ग्रामपंचायत नागठाणे</div>

          {/* DESKTOP NAV */}
          <nav className="nav-links">
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              मूख्यपृष्ठ
            </NavLink>

            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              आमच्याविषयी
            </NavLink>

            <NavLink
              to="/achievements"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              यशोगाथा
            </NavLink>

            <NavLink
              to="/gallery"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              गॅलरी
            </NavLink>

            <NavLink
              to="/campaign"
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              मुख्यमंत्री अभियान
            </NavLink>
          </nav>

          {/* CONTACT BTN WITH ACTIVE STYLE */}
          <NavLink to="/contact" className="contact-btn">
            संपर्क करा
          </NavLink>

          {/* HAMBURGER */}
          <div
            className={`hamburger ${open ? "active" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      {/* MOBILE NAV */}
      <div className={`mobile-nav ${open ? "show" : ""}`}>
        <NavLink
          to="/"
          onClick={handleLinkClick}
          className={({ isActive }) => (isActive ? "active-mobile" : "")}
        >
          मूख्यपृष्ठ
        </NavLink>

        <NavLink
          to="/about"
          onClick={handleLinkClick}
          className={({ isActive }) => (isActive ? "active-mobile" : "")}
        >
          आमच्याविषयी
        </NavLink>

        <NavLink
          to="/achievements"
          onClick={handleLinkClick}
          className={({ isActive }) => (isActive ? "active-mobile" : "")}
        >
          यशोगाथा
        </NavLink>

        <NavLink
          to="/gallery"
          onClick={handleLinkClick}
          className={({ isActive }) => (isActive ? "active-mobile" : "")}
        >
          गॅलरी
        </NavLink>

        <NavLink
          to="/campaign"
          onClick={handleLinkClick}
          className={({ isActive }) => (isActive ? "active-mobile" : "")}
        >
          मुख्यमंत्री अभियान
        </NavLink>

        {/* MOBILE CONTACT ACTIVE STYLE */}
        {/* <NavLink 
          to="/contact"
          onClick={handleLinkClick}
          className={({ isActive }) =>
            isActive ? "mobile-contact-btn active-mobile" : "mobile-contact-btn"
          }
        >
          संपर्क करा
        </NavLink> */}
        <NavLink to="/contact" className="mobile-contact-btn">
          संपर्क करा
        </NavLink>
      </div>

      {/* OVERLAY */}
      {open && <div className="overlay" onClick={() => setOpen(false)}></div>}
    </>
  );
};

export default Header;
